import React from 'react';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import AddInternalVersion from './AddInternalVersion';
import Cookies from 'js-cookie';
import Sorting from './Sorting';
import { is_allowed } from '../utilitis';

//internal version component to be displayed on version section
export default class InternalVersion extends React.Component {
  state = {
    error: '',
    modalIsOpenAddInternalVersion: false,
    versionData: [],
    actualData: [],
    selectedVersion: '',
    sortingStatus: {
      sortingName: '',
      defaultDown: true
    },
  }

  openModal = (e) => {
    this.setState({
      modalIsOpenAddInternalVersion: false
    }, () => {
      this.setState({
        modalIsOpenAddInternalVersion: true
      })
    })
  }

  ActivateAddInternalVersionModal = (e) => {
    if (this.state.modalIsOpenAddInternalVersion) {
      return <AddInternalVersion activeModal={true} refreshVersion={this.refreshVersion.bind(this)} versionData={this.state.versionData} />
    } else {
      return null
    }
  }

  restoreData = (data) => {
    this.setState({
      versionData: data,
    })
  }

  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.versionData);
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.versionData);
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }


  componentWillMount() {
    this.fetchVersion()
  }

  refreshVersion = (e) => {
    this.fetchVersion();
    this.setState({
      modalIsOpenAddInternalVersion: false
    })
  }


  fetchVersion = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/versioncontrol/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        // console.log(data)
        this.setState({
          versionData: data,
          actualData: data
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  renderVersionData = () => {
    let element = this.state.versionData.map((firstElement, index) => {
      const releaseDate = new Date(firstElement.release_date * 1000);
      return (
        <React.Fragment>
          <tr>
            <td scope="col" style={{ width: '15%', fontSize:'12px' }}>{firstElement.application_name}</td>
            <td scope="col" style={{ width: '15%', fontSize:'12px' }}>{firstElement.application_version}</td>
            <td scope="col" style={{ width: '20%', fontSize:'12px' }}>{releaseDate.toString()}</td>
            <td scope="col" style={{ width: '120px', fontSize:'12px' }}>
              <a rel="stylesheet" style={{ color: '#00AEA7' }}
                onClick={() => {
                  let firstPath = window.location.origin + '/';
                  if (process.env.NODE_ENV === "development") {
                    window.open("http://192.168.0.49:8007/" + firstElement.file + ".pdf")

                  } else {
                    window.open(firstPath + firstElement.file + ".pdf")
                  }
                }
                }
              >View</a>
            </td>
            <td scope="col" style={{ width: '40%', whiteSpace: 'pre-wrap' , fontSize:'12px'}}>{firstElement.release_note}</td>
          </tr>
        </React.Fragment>
      );
    })
    return element
  }

  overlayShadowUnderModal = () => {
    if (this.state.modalIsOpenAddInternalVersion) {
      return (
        <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, overflow: 'hidden', width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0' }}></div>
      )
    } else {
      return null
    }
  }

  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.overlayShadowUnderModal()}
        <div style={{ width: '100%', paddingLeft: '6px', paddingTop: '40px', paddingRight: '20px' }}>
          <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }} className="text-uppercase">Version Control: Internal</span>
            <span style={{ float: 'right' }}>
              <div className="row" style={{ margin: '0' }}>
                <div className="pointer" onClick={this.openModal.bind(this)} >
                  {/* {console.log("version",this.props)} */}
                  {/* {(
                    localStorage.getItem("user_type") === "1" ||
                    (
                      localStorage.getItem("user_type") === "2" &&
                      is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "version", "add")
                    )
                  ) && ( */}
                      <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                        {/* <Icon icon={iosPlusEmpty} size={30} style={{ color: "#F08100", backgroundColor: "none",marginLeft: '5px' }} /> */}
                        <IconButton sx={{
                          color: '#F08100',
                          fontSize: 40,
                          backgroundColor: 'transparent',
                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          '&:focus': {
                            outline: 'none',
                            border: 'none',
                            backgroundColor: 'transparent'
                          }
                        }} aria-label="add">
                          <AddIcon sx={{ fontSize: 40 }} />
                        </IconButton>
                        <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600', marginRight: '5px', marginLeft: '5px' }}>ADD NEW VERSION</span>
                      </div>
                    {/* )} */}
                </div>
              </div>
            </span>
          </div>
          <table className="table">
            <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
              <th scope="col" style={{ width: '15%', fontSize: '12px' }}>
                Application Name
                <i class={this.fetchIconType('application_name')} onClick={(e) => { this.sortingFunc('application_name') }}>
                </i>
              </th>
              <th scope="col" style={{ width: '15%', fontSize: '12px' }}>
                Application Version
                <i class={this.fetchIconType('application_version')} onClick={(e) => { this.sortingFunc('application_version') }}>
                </i>
              </th>
              <th scope="col" style={{ width: '20%', fontSize: '12px' }}>
                Release Date & Time
                <i class={this.fetchIconType('release_date')} onClick={(e) => { this.sortingFunc('release_date') }}>
                </i>
              </th>
              <th scope="col" style={{ width: '120px', fontSize: '12px' }}>
                Attachment
              </th>
              <th scope="col" style={{ width: '40%', fontSize: '12px' }}>
                Release Notes
              </th>
            </thead>
            <tbody style={{ maxHeight: `${window.innerHeight - 250}px`, overflowY: 'overlay', height: 'auto' }}>
              {this.renderVersionData()}
            </tbody>
          </table>
        </div>
        {this.ActivateAddInternalVersionModal()}
      </React.Fragment>
    )
  }
}